/**
 * Client wrapper for the updateUserName Cloud Function.
 */
import { type Functions, httpsCallable } from 'firebase/functions';

export interface UpdateUserNameResult {
  accepted: boolean;
  resetTo?: string;
  warningPending?: boolean;
  action?: string;
}

export async function callUpdateUserName(
  funcs: Functions,
  name: string,
): Promise<UpdateUserNameResult> {
  const fn = httpsCallable<{ name: string }, UpdateUserNameResult>(funcs, 'updateUserName');
  const result = await fn({ name });
  return result.data;
}

export async function callAcknowledgeNamePolicyWarning(funcs: Functions): Promise<void> {
  const fn = httpsCallable(funcs, 'acknowledgeNamePolicyWarning');
  await fn({});
}
